import { AnalyticsEventFragment } from 'services/graphql/fragments/HomeTilesContentFragment';
import { gql } from 'urql';

export const ActivatePartnerOffer = gql`
  mutation ActivatePartnerOffer($input: ActivatePartnerOfferInput!) {
    activatePartnerOffer(input: $input) {
      ... on ActivatePartnerOfferSuccess {
        __typename
        id
        activatedOfferId
        title
        displayAnalytics {
          ...AnalyticsEventFragment
        }
        instructions {
          id
          icon
          text
          expiryDay
        }
        primaryButton {
          id
          buttonStyle
          buttonText
        }
        offerSource
      }
      ... on ActivationMaximumReached {
        __typename
        header
        body
        deprecatedMessage: message
        maxActivations
        displayAnalytics {
          ...AnalyticsEventFragment
        }
        button {
          id
          buttonStyle
          buttonText
          buttonOnClick {
            __typename
            ... on OpenURLNavigationAction {
              url
              analyticsEvent {
                ...AnalyticsEventFragment
              }
            }
          }
        }
      }
      ... on DailyRedemptionMaxReached {
        __typename
        header
        body
        deprecatedMessage: message
        maxDailyRedemptions
        button {
          id
          buttonStyle
          buttonText
          buttonOnClick {
            __typename
            ... on OpenURLNavigationAction {
              url
            }
          }
        }
      }
      ... on ActivatePartnerOfferError {
        __typename
        code
        message
      }
    }
  }
  ${AnalyticsEventFragment}
`;

export default ActivatePartnerOffer;
